// Memento PWA helpers — registrazione service worker + beforeinstallprompt handler
// Il prompt viene esposto come `window.__memento_install()` così che i componenti
// (es. banner installazione) possano triggerarlo con un click utente.

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Solo in produzione o quando servito da HTTPS/localhost (SW richiede secure context)
  const isLocalhost =
    ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname) ||
    window.location.hostname.endsWith(".local");
  if (!(window.isSecureContext || isLocalhost)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch(() => { /* silenzioso in dev */ });
  });

  // Cattura evento install prompt per attivarlo con click utente
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__memento_installPrompt = e;
    window.dispatchEvent(new CustomEvent("memento:install-available"));
  });

  window.__memento_install = async () => {
    const p = window.__memento_installPrompt;
    if (!p) return "unavailable";
    p.prompt();
    const choice = await p.userChoice;
    window.__memento_installPrompt = null;
    return choice.outcome; // "accepted" | "dismissed"
  };
}
